import { useCurrentUser } from "./useCurrentUser";

export function useCurrentUserLevel() {
  return useCurrentUser()?.level;
}
